import React from 'react';
import { motion } from 'framer-motion';
import { Wrench, AlertTriangle } from 'lucide-react';
import { cn } from '../../lib/utils';

export const ToolsList = ({ tools = [], className }) => {
  if (!tools.length) return null;

  return (
    <div className={cn('space-y-3', className)} data-testid="tools-list">
      <div className="flex items-center gap-2">
        <Wrench className="w-4 h-4 text-secondary" />
        <span className="font-heading text-sm uppercase tracking-wide text-text-secondary">
          Tools Required
        </span>
      </div>
      
      <div className="flex flex-wrap gap-2">
        {tools.map((tool, index) => (
          <motion.div
            key={tool}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.05 }}
            className="px-3 py-1.5 bg-surface border border-border text-text-primary 
                     font-mono text-sm flex items-center gap-2"
            data-testid={`tool-item-${index}`}
          >
            <div className="w-1.5 h-1.5 bg-secondary" />
            {tool}
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ToolsList;
